document.addEventListener('DOMContentLoaded', function () {

  let cabinetOptions = {};

  let currentDoor = null;
  let currentMaterial = null;
  let currentFinish = null;


  /*
  ==================================================
  LOAD JSON
  ==================================================
  */

  fetch(window.cabinetOptionsUrl)
    .then(response => response.json())
    .then(data => {

      cabinetOptions = data;

      initCabinetBuilder();

    })
    .catch(error => {

      console.error(
        'Cabinet options failed to load:',
        error
      );

    });


  /*
  ==================================================
  GENERIC SLIDER
  ==================================================
  */

  function initSlider(
    sliderSelector,
    prevSelector,
    nextSelector
  ) {

    const slider =
      document.querySelector(sliderSelector);

    const prevBtn =
      document.querySelector(prevSelector);

    const nextBtn =
      document.querySelector(nextSelector);

    if (!slider || !prevBtn || !nextBtn) {
      return;
    }


    /*
    REMOVE OLD EVENTS
    */

    const newPrevBtn =
      prevBtn.cloneNode(true);

    const newNextBtn =
      nextBtn.cloneNode(true);

    prevBtn.parentNode.replaceChild(
      newPrevBtn,
      prevBtn
    );

    nextBtn.parentNode.replaceChild(
      newNextBtn,
      nextBtn
    );


    /*
    PREV
    */

    newPrevBtn.addEventListener(
      'click',
      function () {

        slider.scrollBy({
          left: -300,
          behavior: 'smooth'
        });

      }
    );


    /*
    NEXT
    */

    newNextBtn.addEventListener(
      'click',
      function () {

        slider.scrollBy({
          left: 300,
          behavior: 'smooth'
        });

      }
    );

  }


  /*
  ==================================================
  INIT
  ==================================================
  */

  function initCabinetBuilder() {

    /*
    ==================================================
    VALIDATE CABINET OPTIONS
    ==================================================
    */

    if (
      !cabinetOptions.door_styles ||
      !cabinetOptions.door_styles.length
    ) {

      console.error(
        'No cabinet door styles found.'
      );

      return;

    }


    /*
    ==================================================
    DEFAULT VALUES
    ==================================================
    */

    const firstDoor =
      cabinetOptions.door_styles[0];

    const defaultDoor =
      firstDoor.name;

    const defaultMaterial =
      Object.keys(
        firstDoor.materials
      )[0];

    const defaultFinish =
      firstDoor.materials[
        defaultMaterial
      ].finishes[0].name;


    /*
    ==================================================
    LOAD FROM URL / STORAGE
    ==================================================
    */

    const params =
      new URLSearchParams(
        window.location.search
      );


    currentDoor =
      params.get('style') ||
      localStorage.getItem(
        'cabinetDoorStyle'
      ) ||
      defaultDoor;


    currentMaterial =
      params.get('material') ||
      localStorage.getItem(
        'cabinetMaterial'
      ) ||
      defaultMaterial;


    currentFinish =
      params.get('finish') ||
      localStorage.getItem(
        'cabinetFinish'
      ) ||
      defaultFinish;


    /*
    ==================================================
    NORMALIZE SELECTION
    ==================================================
    */

    normalizeSelection();


    /*
    ==================================================
    PROTECT CUSTOM CABINET URL
    ==================================================
    */

    installURLProtection();


    /*
    ==================================================
    HELPERS
    ==================================================
    */

    function normalizeSelection() {

      let selectedDoor =
        cabinetOptions.door_styles.find(
          d => d.name === currentDoor
        );


      /*
      INVALID DOOR
      */

      if (!selectedDoor) {

        currentDoor =
          defaultDoor;

        selectedDoor =
          cabinetOptions.door_styles.find(
            d => d.name === currentDoor
          );

      }


      /*
      INVALID MATERIAL
      */

      if (
        !selectedDoor.materials[
          currentMaterial
        ]
      ) {

        currentMaterial =
          Object.keys(
            selectedDoor.materials
          )[0];

      }


      /*
      INVALID FINISH
      */

      const finishes =
        selectedDoor.materials[
          currentMaterial
        ].finishes;


      const finishExists =
        finishes.some(
          f =>
            f.name === currentFinish
        );


      if (!finishExists) {

        currentFinish =
          finishes[0].name;

      }

    }


    function getSelectedDoor() {

      return cabinetOptions.door_styles.find(
        door =>
          door.name === currentDoor
      );

    }


    function getAllFinishOptions() {

      const finishOptions = [];


      cabinetOptions.door_styles.forEach(
        function (style) {

          Object.entries(
            style.materials
          ).forEach(
            function (
              [materialName, materialData]
            ) {

              materialData.finishes.forEach(
                function (finishObj) {

                  const exists =
                    finishOptions.some(
                      function (item) {

                        return (
                          item.material ===
                            materialName &&
                          item.finish ===
                            finishObj.name
                        );

                      }
                    );


                  if (!exists) {

                    finishOptions.push({

                      material:
                        materialName,

                      finish:
                        finishObj.name,

                      label:
                        `${materialName} ${finishObj.name}`,

                      color:
                        finishObj.color

                    });

                  }

                }
              );

            }
          );

        }
      );


      return finishOptions;

    }


    /*
    ==================================================
    DOOR STYLE DESCRIPTION
    ==================================================
    */

    function updateDoorStyleDescription() {

      const description =
        document.getElementById(
          'door-style-description'
        );


      if (!description) {
        return;
      }


      if (!window.doorStyleDescriptions) {

        description.innerHTML = '';

        return;

      }


      const selectedDoor =
        window.sampleDoorStyle ||
        currentDoor;


      const matched =
        window.doorStyleDescriptions.find(
          function (item) {

            return (
              item.name ===
              selectedDoor
            );

          }
        );


      description.innerHTML =
        matched
          ? matched.description
          : '';

    }


    /*
    ==================================================
    SAVE
    ==================================================
    */

    function saveSelections() {

      localStorage.setItem(
        'cabinetDoorStyle',
        currentDoor
      );

      localStorage.setItem(
        'cabinetMaterial',
        currentMaterial
      );

      localStorage.setItem(
        'cabinetFinish',
        currentFinish
      );

    }


    /*
    ==================================================
    BUILD CUSTOM CABINET URL
    ==================================================
    */

    function getCabinetURL() {

      const url =
        new URL(
          window.location.href
        );


      /*
      Remove Shopify variant parameter
      */

      url.searchParams.delete(
        'variant'
      );


      /*
      Restore cabinet parameters
      */

      url.searchParams.set(
        'style',
        currentDoor
      );

      url.searchParams.set(
        'material',
        currentMaterial
      );

      url.searchParams.set(
        'finish',
        currentFinish
      );


      return url;

    }


    /*
    ==================================================
    RESTORE CUSTOM CABINET URL
    ==================================================
    */

    function restoreCabinetURL() {

      const url =
        getCabinetURL();


      const currentURL =
        window.location.href;


      const targetURL =
        url.toString();


      if (
        currentURL !==
        targetURL
      ) {

        window.history.replaceState(
          window.history.state,
          '',
          targetURL
        );

      }

    }


    /*
    ==================================================
    URL PROTECTION
    ==================================================
    */

    function installURLProtection() {

      /*
      Prevent installing this more than once.
      */

      if (
        window.__cabinetURLProtectionInstalled
      ) {

        return;

      }


      window.__cabinetURLProtectionInstalled =
        true;


      /*
      Save native functions.
      */

      const nativeReplaceState =
        window.history.replaceState.bind(
          window.history
        );


      const nativePushState =
        window.history.pushState.bind(
          window.history
        );


      /*
      ==================================================
      REPLACE STATE
      ==================================================
      */

      window.history.replaceState =
        function (
          state,
          title,
          url
        ) {

          try {

            if (url) {

              const newURL =
                new URL(
                  url,
                  window.location.origin
                );


              /*
              If Shopify tries to add ?variant=
              while cabinet parameters exist,
              remove variant and preserve
              style/material/finish.
              */

              if (
                newURL.searchParams.has(
                  'variant'
                ) &&
                newURL.searchParams.has(
                  'style'
                ) === false &&
                newURL.searchParams.has(
                  'material'
                ) === false &&
                newURL.searchParams.has(
                  'finish'
                ) === false
              ) {

                const currentURL =
                  new URL(
                    window.location.href
                  );


                const style =
                  currentURL.searchParams.get(
                    'style'
                  );

                const material =
                  currentURL.searchParams.get(
                    'material'
                  );

                const finish =
                  currentURL.searchParams.get(
                    'finish'
                  );


                if (
                  style &&
                  material &&
                  finish
                ) {

                  newURL.searchParams.delete(
                    'variant'
                  );


                  newURL.searchParams.set(
                    'style',
                    style
                  );


                  newURL.searchParams.set(
                    'material',
                    material
                  );


                  newURL.searchParams.set(
                    'finish',
                    finish
                  );

                }

              }


              url =
                newURL.toString();

            }

          }
          catch (error) {

            console.warn(
              'Cabinet URL protection error:',
              error
            );

          }


          return nativeReplaceState(
            state,
            title,
            url
          );

        };


      /*
      ==================================================
      PUSH STATE
      ==================================================
      */

      window.history.pushState =
        function (
          state,
          title,
          url
        ) {

          try {

            if (url) {

              const newURL =
                new URL(
                  url,
                  window.location.origin
                );


              if (
                newURL.searchParams.has(
                  'variant'
                )
              ) {

                const currentURL =
                  new URL(
                    window.location.href
                  );


                const style =
                  currentURL.searchParams.get(
                    'style'
                  );

                const material =
                  currentURL.searchParams.get(
                    'material'
                  );

                const finish =
                  currentURL.searchParams.get(
                    'finish'
                  );


                if (
                  style &&
                  material &&
                  finish
                ) {

                  newURL.searchParams.delete(
                    'variant'
                  );


                  newURL.searchParams.set(
                    'style',
                    style
                  );


                  newURL.searchParams.set(
                    'material',
                    material
                  );


                  newURL.searchParams.set(
                    'finish',
                    finish
                  );


                  url =
                    newURL.toString();

                }

              }

            }

          }
          catch (error) {

            console.warn(
              'Cabinet pushState protection error:',
              error
            );

          }


          return nativePushState(
            state,
            title,
            url
          );

        };

    }


    /*
    ==================================================
    UPDATE URL
    ==================================================
    */

    function updateURL() {

      restoreCabinetURL();

    }


    /*
    ==================================================
    UPDATE PRODUCT LINKS
    ==================================================
    */

    function updateProductLinks() {

      const productLinks =
        document.querySelectorAll(
          '.card-wrapper a, .full-unstyled-link'
        );


      productLinks.forEach(
        function (link) {

          const href =
            link.getAttribute(
              'href'
            );


          if (
            !href ||
            !href.includes(
              '/products/'
            )
          ) {

            return;

          }


          const url =
            new URL(
              href,
              window.location.origin
            );


          url.searchParams.set(
            'style',
            currentDoor
          );


          url.searchParams.set(
            'material',
            currentMaterial
          );


          url.searchParams.set(
            'finish',
            currentFinish
          );


          url.searchParams.delete(
            'variant'
          );


          link.setAttribute(
            'href',
            url.pathname +
            url.search
          );

        }
      );

    }


    /*
    ==================================================
    GET PRICE GROUP
    ==================================================
    */

    function getPriceGroup() {

      const selectedDoor =
        getSelectedDoor();


      if (!selectedDoor) {
        return null;
      }


      const materialData =
        selectedDoor.materials[
          currentMaterial
        ];


      if (!materialData) {
        return null;
      }


      const matchedFinish =
        materialData.finishes.find(
          function (finishObj) {

            return (
              finishObj.name ===
              currentFinish
            );

          }
        );


      if (!matchedFinish) {
        return null;
      }


      return (
        matchedFinish.price_group ||
        materialData.price_group ||
        null
      );

    }


    /*
    ==================================================
    UPDATE DISPLAYED PRICE
    ==================================================
    */

    function updateDisplayedPrice(
      matchedVariant
    ) {

      if (!matchedVariant) {
        return;
      }


      const formattedPrice =
        '$' +
        (
          matchedVariant.price /
          100
        ).toFixed(2);


      /*
      SALE / CURRENT PRICE
      */

      const salePriceElements =
        document.querySelectorAll(
          '.price-item--sale'
        );


      if (
        salePriceElements.length
      ) {

        salePriceElements.forEach(
          function (element) {

            element.textContent =
              formattedPrice;

          }
        );

      }
      else {

        /*
        REGULAR CURRENT PRICE
        */

        const regularPriceElements =
          document.querySelectorAll(
            '.price-item--regular'
          );


        regularPriceElements.forEach(
          function (element) {

            element.textContent =
              formattedPrice;

          }
        );

      }


      console.log(
        'PRICE UPDATED TO:',
        formattedPrice
      );

    }


    /*
    ==================================================
    UPDATE PRODUCT VARIANT
    ==================================================
    */

    function updateProductVariant() {

      if (
        !window.productVariants ||
        !window.productVariants.length
      ) {

        console.warn(
          'productVariants not available'
        );

        return;

      }


      const group =
        getPriceGroup();


      if (!group) {

        console.warn(
          'No price group found'
        );

        return;

      }


      console.log(
        'Selected Price Group:',
        group
      );


      /*
      ==================================================
      FIND MATCHING VARIANT
      ==================================================
      */

      const matchedVariant =
        window.productVariants.find(
          function (variant) {

            return (
              String(
                variant.option1
              ).trim() ===
              String(
                group
              ).trim()
            );

          }
        );


      if (!matchedVariant) {

        console.warn(
          'Variant not found:',
          group
        );

        return;

      }


      console.log(
        'Matched Variant:',
        matchedVariant
      );


      /*
      ==================================================
      FIND RADIO
      ==================================================
      */

      const variantInputs =
        document.querySelectorAll(
          'variant-selects input[type="radio"]'
        );


      let selectedInput =
        null;


      variantInputs.forEach(
        function (input) {

          const isSelected =
            String(
              input.value
            ).trim() ===
            String(
              group
            ).trim();


          if (isSelected) {

            selectedInput =
              input;

          }

        }
      );


      /*
      ==================================================
      SELECT SHOPIFY VARIANT
      ==================================================
      */

      if (selectedInput) {

        selectedInput.checked =
          true;


        selectedInput.setAttribute(
          'checked',
          'checked'
        );


        /*
        IMPORTANT:
        This triggers Shopify's native
        variant-change system.
        */

        selectedInput.dispatchEvent(
          new Event(
            'change',
            {
              bubbles: true
            }
          )
        );

      }


      /*
      REMOVE OTHER RADIO STATES
      */

      variantInputs.forEach(
        function (input) {

          if (
            input !==
            selectedInput
          ) {

            input.checked =
              false;

            input.removeAttribute(
              'checked'
            );

          }

        }
      );


      /*
      ==================================================
      UPDATE HIDDEN VARIANT ID
      ==================================================
      */

      document.querySelectorAll(
        'input[name="id"]'
      ).forEach(
        function (input) {

          input.value =
            matchedVariant.id;

        }
      );


      /*
      ==================================================
      UPDATE PRICE
      ==================================================
      */

      updateDisplayedPrice(
        matchedVariant
      );


      /*
      Shopify may re-render price.
      */

      setTimeout(
        function () {

          updateDisplayedPrice(
            matchedVariant
          );

        },
        100
      );


      /*
      ==================================================
      UPDATE SKU
      ==================================================
      */

      const skuElement =
        document.querySelector(
          '.product-sku-value'
        );


      if (skuElement) {

        skuElement.textContent =
          matchedVariant.sku || '';

      }


      /*
      ==================================================
      RESTORE CUSTOM URL
      ==================================================
      */

      restoreCabinetURL();


      /*
      Extra safety after Shopify's
      async product-info request.
      */

      setTimeout(
        function () {

          restoreCabinetURL();

        },
        500
      );


      setTimeout(
        function () {

          restoreCabinetURL();

        },
        1000
      );


      /*
      ==================================================
      DEBUG
      ==================================================
      */

      console.log(
        'FINAL VARIANT:',
        {
          id:
            matchedVariant.id,

          group:
            matchedVariant.option1,

          price:
            matchedVariant.price,

          sku:
            matchedVariant.sku
        }
      );

    }


    /*
    ==================================================
    COLLECTION PAGE
    ==================================================
    */

    const doorStyleList =
      document.getElementById(
        'door-style-list'
      );


    const finishList =
      document.getElementById(
        'finish-list'
      );


    if (
      doorStyleList &&
      finishList
    ) {


      /*
      ==================================================
      DOOR STYLES
      ==================================================
      */

      function renderDoorStyles() {

        doorStyleList.innerHTML =
          '';


        const filteredDoorStyles =
          cabinetOptions.door_styles.filter(
            function (styleObj) {

              const materialData =
                styleObj.materials[
                  currentMaterial
                ];


              if (!materialData) {
                return false;
              }


              return materialData.finishes.some(
                function (finishObj) {

                  return (
                    finishObj.name ===
                    currentFinish
                  );

                }
              );

            }
          );


        const currentDoorExists =
          filteredDoorStyles.some(
            function (styleObj) {

              return (
                styleObj.name ===
                currentDoor
              );

            }
          );


        if (
          !currentDoorExists &&
          filteredDoorStyles.length
        ) {

          currentDoor =
            filteredDoorStyles[0].name;

        }


        filteredDoorStyles.forEach(
          function (styleObj) {

            const materialData =
              styleObj.materials[
                currentMaterial
              ];


            const selectedFinish =
              materialData.finishes.find(
                function (finishObj) {

                  return (
                    finishObj.name ===
                    currentFinish
                  );

                }
              );


            const doorImage =
              selectedFinish?.door_image ||
              styleObj.image ||
              '';


            const item =
              document.createElement(
                'li'
              );


            item.className =
              'cabinet-chip';


            item.innerHTML = `
              <button
                type="button"
                class="
                  cabinet-door-card
                  ${
                    styleObj.name === currentDoor
                      ? 'active'
                      : ''
                  }
                "
              >

                <div class="cabinet-door-image">

                  <img
                    src="${doorImage}"
                    alt="${styleObj.name}"
                  >

                </div>

                <div class="cabinet-door-label">
                  ${styleObj.name}
                </div>

              </button>
            `;


            item.querySelector(
              'button'
            ).addEventListener(
              'click',
              function () {

                currentDoor =
                  styleObj.name;


                saveSelections();

                updateURL();

                updateProductLinks();

                renderDoorStyles();


                const selectedDoor =
                  document.getElementById(
                    'selected-door-style'
                  );


                if (selectedDoor) {

                  selectedDoor.textContent =
                    currentDoor;


                  updateDoorStyleDescription();

                  updateProductVariant();

                }

              }
            );


            doorStyleList.appendChild(
              item
            );

          }
        );


        initSlider(
          '#door-style-list',
          '.cabinet-slider-prev',
          '.cabinet-slider-next'
        );

      }


      /*
      ==================================================
      FINISHES
      ==================================================
      */

      function renderFinishes() {

        finishList.innerHTML =
          '';


        const finishOptions =
          getAllFinishOptions();


        finishOptions.forEach(
          function (option) {

            const item =
              document.createElement(
                'li'
              );


            item.className =
              'cabinet-swatch';


            item.innerHTML = `
              <button
                type="button"
                class="
                  cabinet-finish-card
                  ${
                    option.material === currentMaterial &&
                    option.finish === currentFinish
                      ? 'active'
                      : ''
                  }
                "
              >

                <div
                  class="cabinet-swatch-circle"
                  style="
                    background:${option.color}
                  "
                ></div>

                <div class="cabinet-swatch-label">
                  ${option.label}
                </div>

              </button>
            `;


            item.querySelector(
              'button'
            ).addEventListener(
              'click',
              function () {

                currentMaterial =
                  option.material;


                currentFinish =
                  option.finish;


                /*
                FIND FIRST VALID DOOR
                */

                const validDoor =
                  cabinetOptions.door_styles.find(
                    function (styleObj) {

                      const materialData =
                        styleObj.materials[
                          currentMaterial
                        ];


                      if (!materialData) {
                        return false;
                      }


                      return materialData.finishes.some(
                        function (finishObj) {

                          return (
                            finishObj.name ===
                            currentFinish
                          );

                        }
                      );

                    }
                  );


                if (validDoor) {

                  currentDoor =
                    validDoor.name;

                }


                saveSelections();

                updateURL();

                updateProductLinks();

                renderFinishes();

                renderDoorStyles();


                const selectedDoor =
                  document.getElementById(
                    'selected-door-style'
                  );


                if (selectedDoor) {

                  selectedDoor.textContent =
                    currentDoor;


                  updateDoorStyleDescription();

                  updateProductVariant();

                }

              }
            );


            finishList.appendChild(
              item
            );

          }
        );

      }


      /*
      ==================================================
      INITIAL COLLECTION RENDER
      ==================================================
      */

      renderFinishes();

      renderDoorStyles();

      updateProductLinks();

      updateURL();


      initSlider(
        '#finish-list',
        '.cabinet-finish-prev',
        '.cabinet-finish-next'
      );

    }


    /*
    ==================================================
    PRODUCT PAGE
    ==================================================
    */

    const selectedDoorText =
      document.getElementById(
        'selected-door-style'
      );


    if (
      document.getElementById(
        'door-style-description'
      )
    ) {

      updateDoorStyleDescription();

    }


    if (selectedDoorText) {

      selectedDoorText.textContent =
        currentDoor;


      const selectedMaterial =
        document.getElementById(
          'selected-material'
        );


      if (selectedMaterial) {

        selectedMaterial.textContent =
          currentMaterial;

      }


      const selectedFinish =
        document.getElementById(
          'selected-finish'
        );


      if (selectedFinish) {

        selectedFinish.textContent =
          currentFinish;

      }


      /*
      PRODUCT CUSTOM INPUTS
      */

      const productDoorInput =
        document.getElementById(
          'product-door-style'
        );


      const productMaterialInput =
        document.getElementById(
          'product-material'
        );


      const productFinishInput =
        document.getElementById(
          'product-finish'
        );


      if (productDoorInput) {

        productDoorInput.value =
          currentDoor;

      }


      if (productMaterialInput) {

        productMaterialInput.value =
          currentMaterial;

      }


      if (productFinishInput) {

        productFinishInput.value =
          currentFinish;

      }


      /*
      INITIAL PRODUCT VARIANT
      */

      updateProductVariant();

    }


    /*
    ==================================================
    PRESERVE URL PARAMS AFTER COLLECTION AJAX
    ==================================================
    */

    if (
      window.location.pathname.includes(
        '/collections/'
      )
    ) {

      let lastUrl =
        location.href;


      const observer =
        new MutationObserver(
          function () {

            if (
              location.href !==
              lastUrl
            ) {

              lastUrl =
                location.href;


              restoreCabinetURL();

              updateProductLinks();

            }

          }
        );


      observer.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );

    }

  }

});